import PaginatedTable from '../components/ui/PaginatedTable';
import TableActions from '../components/ui/TableActions';
import CounterPaymentSummary from './CounterPaymentSummary';
import React, { useEffect, useMemo, useRef, useState } from "react";
import BillReceipt from "./BillReciept";
import { calculatePOSTotals } from "./posTotals";
import { printReceipt } from './printReceipt';
import {canPOS} from './posAccess';
import { itemBlockReason, requestedQuantity } from "./posAvailability";
import './pos.css';
import './posWorkspace.css';
import ManagerApproval from './ManagerApproval';
import CashMovementModal from './CashMovementModal';
import {writePending,readPending,clearPending,readPendingCash} from './pendingPayment';


const STORE = {
  name: "Jaggi Sweets",
  tagline: "Official Billing & POS System",
  upi: "jaggisweets@upi",
  footer: [
    "Thank you for shopping at Jaggi Sweets!",
    "Visit Again!",
    "Software by Jaggi Tech",
  ],
};

const genInvoiceId = () =>
  "INV-" + Math.random().toString(36).substring(2, 8).toUpperCase();

const genBillNo = () => {
  const y = new Date().getFullYear();
  const n = Math.floor(Math.random() * 90000 + 10000);
  return `JS-${y}-${n}`;
};

const isWeightItem = (item) => item.uom === "KG";

const lineAmount = (item) => {
  const rate = Number(item.overriddenPrice ?? item.price ?? 0);

  return isWeightItem(item)
    ? (Number(item.grams || 0) / 1000) * rate
    : Number(item.qty || 0) * rate;
};

const makePayloadItems = (items) =>
  items.map((item) => ({
    id: item.id,
    name: item.name,
    qty: isWeightItem(item)
      ? Number(item.grams || 0) / 1000
      : Number(item.qty || 0),
    grams: isWeightItem(item) ? Number(item.grams || 0) : null,
    price: Number(item.overriddenPrice ?? item.price),
  }));

export default function BillingPOS_Enterprise() {
  const [categories, setCategories] = useState([]);
  const [managerApproval,setManagerApproval]=useState(null);
  const [customer,setCustomer]=useState(null);
  const [customerSearch,setCustomerSearch]=useState('');
  const [customerResults,setCustomerResults]=useState([]);
  const [holdSearch,setHoldSearch]=useState('');
  const [showCashMovement,setShowCashMovement]=useState(false);
  const [denominations,setDenominations]=useState({});
  const [closingReason,setClosingReason]=useState('');
  const [billAudit,setBillAudit]=useState([]);
  const [itemSearch, setItemSearch] = useState('');
  const [sessionReady, setSessionReady] = useState(false);
  const [sessionOpenedAt, setSessionOpenedAt] = useState(null);
  const paymentRequestRef = useRef(null);
  const paymentSnapshotRef = useRef(null);
  const [paymentUncertain, setPaymentUncertain] = useState(false);
  const [approvalReady,setApprovalReady]=useState(false);
  const [activeCat, setActiveCat] = useState('all');
  const [bill, setBill] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [discountMode, setDiscountMode] = useState('amount');
  const [discountEntry, setDiscountEntry] = useState('');
  const [appliedPercent, setAppliedPercent] = useState(null);
  const [showDiscount, setShowDiscount] = useState(false);
  const [showPay, setShowPay] = useState(false);
  const [paid, setPaid] = useState(0);
  const [mode, setMode] = useState("Cash");
  const [selectedRow, setSelectedRow] = useState(null);
  const [keypadTarget, setKeypadTarget] = useState("qty");
  const [holds, setHolds] = useState([]);
  const [holdId, setHoldId] = useState(null);
  const [billNo, setBillNo] = useState(genBillNo());
  const [invoiceId, setInvoiceId] = useState(genInvoiceId());
  const [refundMode, setRefundMode] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
  const [remarks, setRemarks] = useState("");
  const barcodeBuffer = useRef("");
  const barcodeTimer = useRef(null);
  const [keypadMode, setKeypadMode] = useState("qty");
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [receiptIdentity, setReceiptIdentity] = useState(null);
  const allow=key=>canPOS(user,key);
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [showOpening, setShowOpening] = useState(false);
  const [openingCash, setOpeningCash] = useState("10000");
  const [openingRemarks, setOpeningRemarks] = useState("");
  const [showDayClosing, setShowDayClosing] = useState(false);
  const [closingSummary, setClosingSummary] = useState(null);
  const [closingActualCash, setClosingActualCash] = useState("");
  const [closingExpenses, setClosingExpenses] = useState(0);
  const [closingLoading, setClosingLoading] = useState(false);
  const [tokenNo, setTokenNo] = useState("");
  const [showVoid, setShowVoid] = useState(false);
  const [voidBillId, setVoidBillId] = useState("");
  const [voidReason, setVoidReason] = useState("");
  const [voidLoading, setVoidLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [billSearch, setBillSearch] = useState("");
  const [tokenSearch, setTokenSearch] = useState("");
  const [billResults, setBillResults] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);
  const [lastPrintedBill, setLastPrintedBill] = useState(null);
  const [showReceiptPreview, setShowReceiptPreview] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [refundReason, setRefundReason] = useState("");
  const [refundLoading, setRefundLoading] = useState(false);
  const [refundBillId, setRefundBillId] = useState(null);
  const [returnToInventory, setReturnToInventory] = useState(true);
  const [showExpense, setShowExpense] = useState(false);
  const [expenseType, setExpenseType] = useState("");
  const [expenseAmount, setExpenseAmount] = useState("");
  const [expenseRemarks, setExpenseRemarks] = useState("");
  const [expenseLoading, setExpenseLoading] = useState(false);

  useEffect(() => {
    checkAuth();
    loadMenu();
    checkDayOpening();
    loadHolds();
  }, []);
  useEffect(()=>{if(user)checkDayOpening();},[user]);

  const checkAuth = async () => {
    try {
      const res = await fetch("/api/billing/me", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status !== "success") {
        window.location.href = "/billinglogin";
        return;
      }

      setUser(data.user);
      if(readPendingCash(data.user))setShowCashMovement(true);
      const saved=readPending(data.user);
      if(saved) {
        paymentRequestRef.current=saved.payload;paymentSnapshotRef.current=saved.snapshot;
        setPaymentUncertain(true);
        setBill(saved.snapshot.items);setDiscount(saved.payload.discount);setMode(saved.payload.payment_mode);
        setAppliedPercent(saved.payload.discount_mode==='percent'?saved.payload.discount_value:null);
        setPaid(saved.payload.received_cash||0);setRemarks(saved.payload.remarks||'');setHoldId(saved.payload.hold_id);
        setCustomer(saved.snapshot.customer||null);setShowPay(true);
        try {
          const statusRes=await fetch(`/api/pos/checkout/${saved.payload.request_id}`,{credentials:'include'});
          const status=await statusRes.json();
          if(status.status==='success' && status.saved) {
            const billRes=await fetch(`/api/pos/bill/${status.bill_id}`,{credentials:'include'});
            const receipt=await billRes.json();
            if(receipt.status!=='success')throw new Error('Could not recover receipt');
            setLastPrintedBill(receipt.bill);setBill([]);setDiscount(0);setCustomer(null);setShowPay(false);setPaymentUncertain(false);
            paymentRequestRef.current=null;clearPending(data.user);
            alert(`Recovered saved payment ${status.bill_no}. It has not been billed twice.`);
          }
        }catch(error){console.error('PAYMENT RECOVERY:',error);alert('Pending payment found. Retry the same payment once the backend is available; do not start another bill.');}
      }
    } catch {
      window.location.href = "/billinglogin";
    }
  };

  const loadHolds = async () => {
    try {
      const res = await fetch("/api/pos/holds", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "success") {
        setHolds(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const loadDayClosing = async () => {
    try {
      const res = await fetch("/api/pos/day-closing-summary", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message);
        return;
      }

      setClosingSummary(data.data);
      setClosingActualCash(data.data.expected_cash);
      setClosingExpenses(0);
      setDenominations({});setClosingReason('');
      setShowDayClosing(true);
    } catch (err) {
      console.error(err);
    }
  };

  const voidBill = async (approvalId) => {
    if (!voidReason.trim()) {
      alert("Please enter a reason.");
      return;
    }

    setVoidLoading(true);

    try {
      const res = await fetch("/api/pos/void-bill", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bill_id: voidBillId,
          reason: voidReason,
          approval_id: typeof approvalId==='string'?approvalId:null,
        }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        if(data.approval_required){setManagerApproval({action:'void',payload:{bill_id:voidBillId,reason:voidReason}});return;}
        alert(data.message);
        console.log(data.message);
        return;
      }

      alert("Bill voided successfully");

      setSelectedBill(null);
      setShowVoid(false);
      setVoidBillId(null);
      setVoidReason("");

      await searchBills();
      await loadMenu();
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setVoidLoading(false);
    }
  };

  const checkDayOpening = async () => {
    try {
    const res = await fetch("/api/pos/day-opening", {
      credentials: "include",
    });

    const data = await res.json();

    if (!res.ok || data.status !== "success") throw new Error(data.message || "Could not check counter session");
    if (data.opened) {
      setSessionReady(true);
      setSessionOpenedAt(data.opened_at);
      setShowOpening(false);
    } else {
      setSessionReady(false);
      setShowOpening(allow('pos.day_open'));
    }
    } catch (error) {
      setSessionReady(false);
      console.error("COUNTER SESSION ERROR:", error);
      alert("Could not check the counter session. Check the backend connection and refresh.");
    }
  };

  const searchBills = async () => {
    try {
    const params = new URLSearchParams();

    if (billSearch) params.append("bill_no", billSearch);

    if (tokenSearch) params.append("token_no", tokenSearch);

    const res = await fetch(
      `/api/pos/bills?${params.toString()}`,
      {
        credentials: "include",
      },
    );

    const data = await res.json();

    if (data.status === "success") setBillResults(data.data);
    else alert(data.message||'Could not load bills');
    }catch(error){console.error(error);alert('Could not load bills. Check the backend connection.');}
  };

  const loadBill = async (id) => {
    try {
    setBillAudit([]);
    const res = await fetch(`/api/pos/bill/${id}`, {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") setSelectedBill(data.bill);
    else alert(data.message||'Could not load bill');
    console.log(data.bill);
    }catch(error){console.error(error);alert('Could not load this bill. Check the backend connection.');}
  };

  const openDay = async () => {
    try {
    if (openingCash === "" || !Number.isFinite(Number(openingCash)) || Number(openingCash) < 0) {
      alert("Enter a valid opening cash amount (zero is allowed).");
      return;
    }
    const res = await fetch("/api/pos/day-opening", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        opening_cash: Number(openingCash),
        remarks: openingRemarks,
      }),
    });

    const data = await res.json();

    await loadHolds();
    if (data.status === "success") {
      await checkDayOpening();
      setShowOpening(false);
    } else {
      alert(data.message || "Could not open counter");
      if (data.opened) await checkDayOpening();
    }
    } catch (error) {
      console.error("DAY OPENING ERROR:", error);
      alert("Could not reach the backend. Check that it is running, then refresh before retrying to avoid opening twice.");
    }
  };

  const closeDay = async () => {
    setClosingLoading(true);

    try {
      const res = await fetch("/api/pos/day-closing", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          actual_cash: Number(closingActualCash),
          expenses: Number(closingExpenses),
          remarks:closingReason,
          denomination_counts:denominations,
        }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message);
        return;
      }

      alert("Day Closed Successfully");

      window.location.href = "/billinglogin";
    } catch (err) {
      console.error(err);
    } finally {
      setClosingLoading(false);
    }
  };

  useEffect(() => {
    setBillNo(refundMode ? `RF-${genBillNo()}` : genBillNo());
    setInvoiceId(genInvoiceId());
  }, [refundMode]);

  const loadMenu = async () => {
    try {
      const res = await fetch("/api/pos/menu", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "success") {
        setCategories(data.data);
        setReceiptIdentity(data.receipt_settings || null);

        if (!activeCat && data.data.length > 0) {
          setActiveCat(data.data[0].id);
        }
      }
    } catch (err) {
      console.error("MENU ERROR:", err);
    }
  };

  const saveBill = async () => {
    if (!paymentRequestRef.current) {
      paymentSnapshotRef.current = {items: bill.map(item => ({...item, amount: lineAmount(item)})),
        subtotal: subTotal, tax_totals: totals.taxes, discount, grand_total: grandTotal,
        payment_mode: mode, remarks,customer,receipt_snapshot:{...receiptIdentity,pricing_mode:'inclusive'},round_off:0};
      paymentRequestRef.current = {
        request_id: crypto.randomUUID(),
        received_cash: mode === 'Cash' ? Number(paid) : null,
        items: makePayloadItems(bill), discount, payment_mode: mode,
        remarks, refund_mode: false, sub_total: subTotal, cgst, sgst,
        grand_total: grandTotal, hold_id: holdId, customer_id:customer?.id||null,
        guest_name:customer?.id?'':customer?.name||'', guest_phone:customer?.id?'':customer?.mobile||'',
        discount_mode:appliedPercent===null?'amount':'percent', discount_value:appliedPercent??discount,
      };
    }
    try {writePending(user,{payload:paymentRequestRef.current,snapshot:paymentSnapshotRef.current});}
    catch(error){paymentRequestRef.current=null;throw new Error('Browser storage is unavailable. Payment was not submitted. Enable session storage before retrying.');}
    const res = await fetch("/api/pos/bill", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paymentRequestRef.current),
    });

    return res.json();
  };

  const saveExpense = async () => {
    if (!expenseType) {
      alert("Select expense type");
      return;
    }

    if (!expenseAmount || Number(expenseAmount) <= 0) {
      alert("Enter valid amount");
      return;
    }

    setExpenseLoading(true);

    try {
      const res = await fetch("/api/pos/expense", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expense_type: expenseType,
          amount: Number(expenseAmount),
          remarks: expenseRemarks,
        }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message);
        return;
      }

      alert("Expense Added");

      setShowExpense(false);
      setExpenseType("");
      setExpenseAmount("");
      setExpenseRemarks("");

      loadDayClosing();
    } catch (err) {
      console.error(err);
      alert("Server Error");
    } finally {
      setExpenseLoading(false);
    }
  };

  const addItem = (item) => {
    if(!allow('pos.sell'))return alert('You have view access only; selling permission is required.');
    if (savingRef.current || paymentUncertain) return;
    const blocked = itemBlockReason(item, sessionReady);
    if (blocked) return alert(`${item.name}: ${blocked}`);
    const existing = bill.find((line) => line.id === item.id);

    if (existing) {
      if (isWeightItem(item)) {
        setSelectedRow(item.id);
        setKeypadMode("weight");
        return;
      }

      setBill(
        bill.map((line) =>
          line.id === item.id ? { ...line, qty: line.qty + 1 } : line,
        ),
      );
      return;
    }

    setBill([
      ...bill,
      {
        ...item,
        uom: item.uom || "PCS",
        qty: 1,
        grams: isWeightItem(item) ? 0 : null,
        overriddenPrice: null,
      },
    ]);

    setSelectedRow(item.id);
    setKeypadMode(isWeightItem(item) ? "weight" : "qty");
  };

  const updateQty = (id, delta) => {
    if (savingRef.current || paymentUncertain || !sessionReady) return;
    setBill(
      bill.map((b) =>
        b.id === id ? { ...b, qty: Math.max(1, b.qty + delta) } : b,
      ),
    );
  };

  const removeItem = (id) => {
    if (savingRef.current || paymentUncertain) return;
    setBill(bill.filter((b) => b.id !== id));
  };

  const subTotal = useMemo(() => {
    return calculatePOSTotals(bill).subtotal;
  }, [bill]);

  const totals = calculatePOSTotals(bill, discount);
  useEffect(() => {
    if (!bill.length) { setAppliedPercent(null); return; }
    if (appliedPercent !== null && !paymentUncertain && !savingRef.current && !approvalReady) {
      setDiscount(Math.round(subTotal * appliedPercent) / 100);
    }
  }, [subTotal, bill.length, appliedPercent, paymentUncertain, approvalReady]);
  const cgst = totals.taxes.CGST || 0;
  const sgst = totals.taxes.SGST || 0;
  const roundOff = totals.roundOff;
  const grandTotal = totals.total;

  const invoiceQR = `Invoice:${billNo}|${invoiceId}|₹${grandTotal}`;
  const upiQR = `upi://pay?pa=${STORE.upi}&pn=${STORE.name}&am=${grandTotal}`;
  const change = paid - grandTotal;

  const onKeypad = (k) => {
    if(!allow('pos.sell')||(keypadMode==='price'&&!allow('pos.price_override')))return;
    if (savingRef.current || paymentUncertain || !sessionReady) return;
    if (!selectedRow && keypadMode !== "paid") return;

    const applyToRow = (fn) => {
      setBill(bill.map((b) => (b.id === selectedRow ? fn(b) : b)));
    };

    if (k === "C") {
      if (keypadMode === "qty") applyToRow((b) => ({ ...b, qty: 1 }));
      if (keypadMode === "weight") applyToRow((b) => ({ ...b, grams: 0 }));
      if (keypadMode === "price")
        applyToRow((b) => ({ ...b, overriddenPrice: null }));
      if (keypadMode === "paid") setPaid(0);
      return;
    }

    if (k === "DEL") {
      if (keypadMode === "qty")
        applyToRow((b) => ({ ...b, qty: Math.floor(b.qty / 10) || 1 }));
      if (keypadMode === "weight")
        applyToRow((b) => ({ ...b, grams: Math.floor((b.grams || 0) / 10) }));
      if (keypadMode === "price")
        applyToRow((b) => ({
          ...b,
          overriddenPrice: Math.floor((b.overriddenPrice || 0) / 10),
        }));
      if (keypadMode === "paid") setPaid(Math.floor(paid / 10));
      return;
    }

    const num = k === "." ? "." : Number(k);

    if (keypadMode === "qty") {
      applyToRow((b) => {
        const next =
          String(b.qty) === "1" ? String(num) : String(b.qty) + String(num);
        return { ...b, qty: Math.max(1, Number(next)) };
      });
    }

    if (keypadMode === "weight") {
      applyToRow((b) => {
        const next = String(b.grams || "") + String(num);
        return { ...b, grams: Number(next) };
      });
    }

    if (keypadMode === "price") {
      applyToRow((b) => {
        const next = String(b.overriddenPrice || "") + String(num);
        return { ...b, overriddenPrice: Number(next) };
      });
    }

    if (keypadMode === "paid") {
      const next =
        String(paid) === "0" ? String(num) : String(paid) + String(num);
      setPaid(Number(next));
    }
  };

  const allItems = useMemo(() => {
    return categories.flatMap((c) => c.items || []);
  }, [categories]);

  const fastItems = useMemo(() => {
    return allItems.filter((item) => item.is_fast_moving);
  }, [allItems]);

  const doPrint = () => {
    if(!allow('pos.print'))return alert('Printing permission is required.');
    if (!lastPrintedBill) return alert('Complete payment before printing a receipt. Use Bill Search for older bills.');
    printReceipt('lastReceipt');
  };

  const printOldBill = () => {if(allow('pos.print'))printReceipt('searchReceipt');};

  const holdBill = async () => {
    if (bill.length === 0) {
      alert("No items in bill");
      return;
    }

    const items = bill.map((item) => ({
      id: item.id,
      name: item.name,
      qty: isWeightItem(item)
        ? Number(item.grams || 0) / 1000
        : Number(item.qty || 0),
      grams: isWeightItem(item) ? Number(item.grams || 0) : null,
      price: Number(item.overriddenPrice ?? item.price),
    }));

    console.log("HOLD ITEMS BEING SENT:", items);

    const invalidWeight = items.find(
      (item) => item.grams !== null && item.grams <= 0,
    );

    if (invalidWeight) {
      alert(`Enter grams for ${invalidWeight.name}`);
      return;
    }

    try {
      const res = await fetch("/api/pos/hold", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          hold_id: holdId,
          items,
          subtotal: subTotal,
          discount,
          grand_total: grandTotal,
          remarks,
          customer_id:customer?.id||null,
          guest_name:customer?.id?'':customer?.name||'',guest_phone:customer?.id?'':customer?.mobile||'',
          discount_mode:appliedPercent===null?'amount':'percent',discount_value:appliedPercent??discount,
        }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message || "Could not hold bill");
        return;
      }

      alert("Bill held successfully");

      setBill([]);
      setDiscount(0);
      setPaid(0);
      setRemarks("");
      setRefundMode(false);
      setHoldId(null);
      setSelectedRow(null);

      await loadHolds();
    } catch (error) {
      console.error(error);
      alert("Could not hold bill");
    }
  };

  const recallBill = async (id) => {
    if (bill.length && !window.confirm('Replace the current unsaved bill with this held bill?')) return;
    if (!sessionReady || paymentUncertain) return;
    try {
      const res = await fetch(`/api/pos/hold/${id}`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status !== "success") {
        alert(data.message || "Could not recall bill");
        return;
      }

      const hold = data.data;

      setHoldId(hold.id);
      setCustomer(hold.customer||null);
      setPaid(0);
      setMode('Cash');
      setRefundMode(false);

      setBill(
        hold.items.map((item) => ({
          id: item.menu_item_id,
          name: item.item_name,
          qty: Number(item.qty || 0),
          price: Number(item.rate || 0),
          uom: item.uom || "PCS",
          gst_mode:item.gst_mode||'inclusive',
          taxes: item.taxes || [],
          grams:
            item.grams !== null && item.grams !== undefined
              ? Number(item.grams)
              : null,
          overriddenPrice: null,
        })),
      );

      setAppliedPercent(hold.billing_snapshot?.discount_mode==='percent'?hold.billing_snapshot.discount_value:null);
      setDiscount(Number(hold.discount || 0));
      setRemarks(hold.remarks || "");
      setSelectedRow(null);
    } catch (error) {
      console.error(error);
      alert("Could not recall bill");
    }
  };

  const refundBill = async (approvalId) => {
    if (!refundReason.trim()) {
      alert("Enter refund reason");
      return;
    }

    setRefundLoading(true);

    try {
      const res = await fetch("/api/pos/refund-bill", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bill_id: refundBillId,
          reason: refundReason,
          return_to_inventory: returnToInventory,
          approval_id:typeof approvalId==='string'?approvalId:null,
        }),
      });

      const data = await res.json();

      if (data.status !== "success") {
        if(data.approval_required){setManagerApproval({action:'refund',payload:{bill_id:refundBillId,reason:refundReason,return_to_inventory:returnToInventory}});return;}
        alert(data.message);
        return;
      }

      alert("Refund completed");

      setShowRefund(false);
      setRefundReason("");
      setReturnToInventory(true);
      setSelectedBill(null);

      searchBills();
      loadMenu();
    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setRefundLoading(false);
    }
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.target.closest('input,textarea,select') || showPay || showOpening || showSearch || !sessionReady || savingRef.current || paymentUncertain) return;
      if (barcodeTimer.current) clearTimeout(barcodeTimer.current);
      if (e.key === "Enter") {
        const code = barcodeBuffer.current;
        barcodeBuffer.current = "";
        const it = allItems.find((x) => x.barcode === code);
        if (it) addItem(it);
      } else {
        barcodeBuffer.current += e.key;
        barcodeTimer.current = setTimeout(() => {
          barcodeBuffer.current = "";
        }, 200);
      }
    };
    window.addEventListener("keypress", onKey);
    return () => window.removeEventListener("keypress", onKey);
  }, [allItems, bill, showPay, showOpening, showSearch, sessionReady, paymentUncertain,user]);

  useEffect(() => {
    const onShort = (e) => {
      if(managerApproval||approvalReady)return;
      if (e.key === "F2" && allow('pos.discount') && sessionReady && !paymentUncertain && !savingRef.current) setShowDiscount(true);
      if (e.key === "F4" && allow('pos.sell') && sessionReady && bill.length > 0) setShowPay(true);
      if (e.ctrlKey && e.key.toLowerCase() === "p") {
        e.preventDefault();
        doPrint();
      }
      if (e.key === "Escape") {
        setShowDiscount(false);
        if (!paymentUncertain && !savingRef.current) setShowPay(false);
        setShowRemarks(false);
      }
    };
    window.addEventListener("keydown", onShort);
    return () => window.removeEventListener("keydown", onShort);
  }, [sessionReady, bill.length, paymentUncertain, lastPrintedBill,managerApproval,approvalReady,user]);

  const selectedCategory = categories.find((c) => c.id === activeCat);
  const visibleItems = (itemSearch.trim() || activeCat==='all' ? allItems : selectedCategory?.items || []).filter(item => `${item.name} ${item.item_code || ''}`.toLowerCase().includes(itemSearch.trim().toLowerCase()));

  useEffect(()=>{
    const timer=setInterval(()=>{if(!document.hidden&&!savingRef.current&&!paymentUncertain){loadMenu();fetch('/api/billing/me',{credentials:'include'}).then(r=>r.json()).then(d=>{if(d.status==='success'&&canPOS(d.user,'pos.view'))setUser(d.user);else window.location.href='/billinglogin';}).catch(()=>{});}},30000);
    return ()=>clearInterval(timer);
  },[activeCat,paymentUncertain]);

  useEffect(()=>{
    let cancelled=false;
    if(customerSearch.trim().length<2){setCustomerResults([]);return;}
    const timer=setTimeout(async()=>{try{const res=await fetch(`/api/pos/customers?search=${encodeURIComponent(customerSearch)}`,{credentials:'include'});const data=await res.json();if(!cancelled&&data.status==='success')setCustomerResults(data.data);}catch(e){console.error(e);}},300);
    return ()=>{cancelled=true;clearTimeout(timer);};
  },[customerSearch]);

  return (
    <div className="erp-ui erp-pos min-h-screen text-white">
      {/* TOP BRAND HEADER */}
      <div className="pos-header flex items-center justify-between px-6 py-3 border-b border-yellow-500/20 bg-black/40 backdrop-blur-xl">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-yellow-400 text-black flex items-center justify-center font-bold text-lg">
            JS
          </div>
          <div>
            <div className="text-yellow-400 text-lg font-semibold tracking-wide">
              Jaggi Sweets
            </div>
            <div className="text-xs text-gray-400">
              Official Billing & POS System
            </div>
          </div>
        </div>

        <div className="flex items-center gap-6 text-sm">
          <a href="/billingdashboard/help?topic=billing-start" target="_blank" rel="noopener noreferrer" className="rounded-lg border border-amber-400/25 px-4 py-2 text-amber-200" aria-label="Open billing guide in a new tab">Guide</a>
          <button disabled={saving || paymentUncertain || approvalReady || (!sessionReady&&!allow('pos.day_open'))} onClick={sessionReady ? loadDayClosing : checkDayOpening} className="pos-session-action rounded-lg px-4 py-2">
            {sessionReady ? 'Day Closing / Summary' : 'Day Opening'}
          </button>
          <button disabled={!sessionReady||paymentUncertain||(!allow('pos.cash_in')&&!allow('pos.cash_out'))} onClick={()=>setShowCashMovement(true)} className="bg-zinc-800 px-4 py-2 rounded-lg">Cash In / Out</button>
          <button
            disabled={!sessionReady || saving || paymentUncertain || approvalReady || !allow('pos.expense')}
            onClick={() => setShowExpense(true)}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
          >
            Add Expense
          </button>
          <button
            onClick={() => setShowSearch(true)}
            className="rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
          >
            Bill Search
          </button>
          <div>
            <span className="text-gray-400">Branch:</span>{" "}
            <span className="text-yellow-400">{user?.branch_name || "-"}</span>
          </div>
          <div>
            <span className="text-gray-400">Counter:</span>{" "}
            <span className="text-yellow-400">{user?.counter_name || "-"}</span>
          </div>
          <div>
            <span className="text-gray-400">Operator:</span>{" "}
            <span className="text-yellow-400">{user?.name || "-"}</span>
          </div>
          <div>
            <span className="text-gray-400">Mode:</span>{" "}
            <span className="text-yellow-400">
              {refundMode ? "Refund" : "Sale"}
            </span>
          </div>
          <button
            onClick={async () => {
              if (savingRef.current || paymentUncertain || approvalReady) return alert('Resolve or cancel the pending payment before logging out.');
              await fetch("/api/billing/logout", {
                method: "POST",
                credentials: "include",
              });

              window.location.href = "/billinglogin";
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {/* POS GRID */}
      <div className="pos-status-strip">
        <span className={sessionReady ? 'pos-live' : 'pos-closed'}>{sessionReady ? '● Counter open' : '● Counter unavailable'}</span>
        <span>{sessionOpenedAt ? `Session started ${new Date(sessionOpenedAt).toLocaleString()}` : 'Open a session to begin billing'}</span>
        <span>{bill.length} items · {holdId ? 'Recalled hold' : 'New sale'}</span>
        {user&&!allow('pos.sell')&&<strong>View-only counter access · selling is not assigned</strong>}
        {lastPrintedBill && <button onClick={()=>setShowReceiptPreview(true)} className="text-amber-300 underline">View / print saved receipt</button>}
        {paymentUncertain && <strong>Payment response pending — retry Complete with the same request; do not start another bill.</strong>}
      </div>
      <div className="pos-workspace p-3 grid grid-cols-4 grid-rows-2 gap-3" data-locked={saving || paymentUncertain || approvalReady || !sessionReady}
        onClickCapture={event => { if ((saving || paymentUncertain || approvalReady || !sessionReady) && !event.target.closest('.fixed')) { event.preventDefault(); event.stopPropagation(); } }}>
        <div className="pos-panel pos-groups row-span-1 rounded-xl bg-white/5 backdrop-blur-xl border border-yellow-500/20 p-3">
          <div className="text-yellow-400 text-xs tracking-widest mb-2">
            GROUPS
          </div>
          <div className="grid grid-cols-2 gap-2">
            <button onClick={()=>setActiveCat('all')} className={`rounded-lg p-3 text-sm border border-amber-400/30 ${activeCat==='all'?'bg-amber-400 text-black':'bg-zinc-900'}`}>All products · {allItems.length}</button>
            {categories.map((c) => (
              <button
                key={c.id}
                onClick={() => setActiveCat(c.id)}
                className={`rounded-lg p-3 text-sm border ${
                  activeCat === c.id
                    ? "bg-yellow-400 text-black"
                    : "bg-zinc-900"
                } border-yellow-500/30`}
              >
                {c.name}
              </button>
            ))}
          </div>
          <section className="pos-held-panel" aria-label="Held bills">
          <div className="pos-panel-title"><span>Held Bills</span><span>{holds.length}</span></div>
          <input aria-label="Search held bills" placeholder="Search holds…" className="pos-item-search" value={holdSearch} onChange={e=>setHoldSearch(e.target.value)} />
          <div className="pos-held-list">
          {holds.filter(h=>`${h.hold_no} ${h.grand_total}`.toLowerCase().includes(holdSearch.toLowerCase())).length === 0 && <p className="pos-empty-state">No matching held bills.</p>}
          {holds.filter(h=>`${h.hold_no} ${h.grand_total}`.toLowerCase().includes(holdSearch.toLowerCase())).map((h) => (
            <button
              key={h.id}
              onClick={() => recallBill(h.id)}
              className="w-full mt-1 rounded-lg p-2 bg-zinc-900 border border-yellow-500/30 flex justify-between"
            >
              <span>{h.hold_no}</span>
              <span>₹{Number(h.grand_total || 0).toFixed(2)}</span>
            </button>
          ))}
          </div>
          </section>
        </div>

        <div className="pos-panel pos-catalog col-span-2 row-span-1 rounded-xl bg-white/5 backdrop-blur-xl border border-yellow-500/20 p-3">
          <div className="text-yellow-400 text-xs tracking-widest mb-2">
            ITEMS
          </div>
          <input aria-label="Search menu items" placeholder="Search item name or code across all categories…" value={itemSearch} onChange={e => setItemSearch(e.target.value)} className="pos-item-search" />
          <div className="pos-catalog-meta">{visibleItems.length} items · final selling prices</div>
          <div className="grid grid-cols-3 gap-2">
            {visibleItems.map((i) => (
              <button
                key={i.id}
                onClick={() => addItem(i)}
                disabled={!allow('pos.sell')||Boolean(itemBlockReason(i, sessionReady))}
                title={itemBlockReason(i, sessionReady) || 'Add to bill'}
                className={`rounded-lg p-3 border
        ${
          itemBlockReason(i, sessionReady)
            ? "bg-gray-700 text-gray-400 cursor-not-allowed opacity-60"
            : "bg-zinc-900 border-yellow-500/30 hover:bg-yellow-500 hover:text-black"
        }`}
              >
                <div className="text-sm">{i.name}</div>{i.inventory_mode==="made_to_order"&&<div className="text-xs text-amber-300">Made to order · kitchen preparation</div>}
                <div className="text-xs text-yellow-400">{i.setup_required?'Selling price not configured':`₹${i.price} / ${i.uom}`}</div>
                {itemBlockReason(i,sessionReady)&&<div className="text-xs">{itemBlockReason(i,sessionReady)}</div>}
              </button>
            ))}
          </div>
        </div>

        <div className="pos-panel pos-fast rounded-xl bg-white/5 backdrop-blur-xl border border-yellow-500/20 p-3">
          <div className="text-yellow-400 text-xs tracking-widest mb-2">
            FAST MOVING
          </div>

          {fastItems.length === 0 ? (
            <div className="text-gray-400 text-sm">No fast moving items</div>
          ) : (
            fastItems.map((item) => (
              <button
                key={item.id}
                onClick={() => addItem(item)}
                disabled={!allow('pos.sell')||Boolean(itemBlockReason(item, sessionReady))}
                title={itemBlockReason(item, sessionReady) || 'Add to bill'}
                className="w-full mb-2 rounded-lg p-3 bg-zinc-900 border border-yellow-500/30 text-left"
              >
                <div>{item.name}</div>{item.inventory_mode==="made_to_order"&&<div className="text-xs text-amber-300">Made to order</div>}
                <div className="text-xs text-yellow-400">₹{item.price} / {item.uom}</div>
                {itemBlockReason(item,sessionReady)&&<div className="text-xs text-gray-400">{itemBlockReason(item,sessionReady)}</div>}
              </button>
            ))
          )}
        </div>

        <div className="pos-panel pos-cart col-span-2 rounded-xl bg-white/5 backdrop-blur-xl border border-yellow-500/20 p-3">
          <div className="text-yellow-400 text-xs tracking-widest mb-2">
            CURRENT BILL · {bill.length} ITEMS
          </div>
          <div className="pos-customer-editor mb-3"><input aria-label="Search billing customer" placeholder="Find customer by name or mobile…" value={customerSearch} onChange={e=>setCustomerSearch(e.target.value)} className="pos-item-search" />
          {!customer?.id && <div className="pos-guest-fields"><label>Guest name<input aria-label="Guest name" placeholder="e.g. Sonu" maxLength={150} value={customer?.name||''} onChange={e=>setCustomer({...customer,name:e.target.value})} /></label><label>Phone number<input aria-label="Customer phone number" type="tel" maxLength={30} placeholder="Customer phone" value={customer?.mobile||''} onChange={e=>setCustomer({...customer,mobile:e.target.value})} /></label></div>}
          {customer&&<div className="text-sm text-amber-300">{customer.name} · {customer.mobile||''} <button onClick={()=>setCustomer(null)}>Clear</button></div>}
          {customerResults.length>0&&<div className="pos-customer-results">{customerResults.map(row=><button key={row.id} className="block w-full text-left text-sm p-2 border-b border-white/10" onClick={()=>{setCustomer(row);setCustomerSearch('');setCustomerResults([]);}}>{row.name} · {row.mobile}</button>)}</div>}</div>
          <div className="pos-current-lines overflow-auto">
            {bill.length === 0 && <div className="pos-empty-state">Your bill is empty. Select an item to begin.</div>}
            {bill.map((b, idx) => (
              <div
                key={b.id}
                onClick={() => {
                  setSelectedRow(b.id);
                  setKeypadTarget("qty");
                }}
                className={`grid grid-cols-12 gap-1 text-sm py-1 ${
                  selectedRow === b.id ? "bg-yellow-500/10" : ""
                }`}
              >
                <div className="col-span-1 text-yellow-400">{idx + 1}</div>
                <div className="col-span-5">{b.name}<small className="pos-source-department">Department: {b.source_department_name||allItems.find(item=>item.id===b.id)?.source_department_name||'Not recorded'}</small><div className="pos-unit-price">₹{Number(b.overriddenPrice??b.price).toFixed(2)} / {b.uom} {isWeightItem(b)&&`× ${Number(b.grams||0)/1000} kg`}</div></div>
                <div className="col-span-2 flex items-center gap-1">
                  {isWeightItem(b) ? (
                    <span>{Number(b.grams || 0)}g</span>
                  ) : (
                    <>
                      <button
                        onClick={() => updateQty(b.id, -1)}
                        className="px-2"
                      >
                        -
                      </button>
                      <span>
                        {b.qty} {b.uom || "PCS"}
                      </span>
                      <button
                        onClick={() => updateQty(b.id, 1)}
                        className="px-2"
                      >
                        +
                      </button>
                    </>
                  )}
                </div>

                <div className="col-span-3 text-right">
                  ₹{lineAmount(b).toFixed(2)}
                </div>
                <div className="col-span-1 text-right">
                  <button onClick={() => removeItem(b.id)}>✕</button>
                </div>
              </div>
            ))}
          </div>

          {bill.find(b=>b.id===selectedRow)?.uom==='KG' && <div className="pos-quick-weights" aria-label="Quick weight selection">{[[250,'250 g'],[500,'500 g'],[1000,'1 kg']].map(([grams,label])=><button key={grams} title={`Add ${label} to selected item`} onClick={()=>{const current=allItems.find(i=>i.id===selectedRow);if(!sessionReady||savingRef.current||paymentUncertain||approvalReady)return;if(!current||itemBlockReason(current,true))return alert('Item is unavailable. Refresh the menu.');setBill(rows=>rows.map(row=>row.id===selectedRow?{...row,grams:Number(row.grams||0)+grams}:row));}}>{label}</button>)}</div>}
          <div className="mt-2 text-xs space-y-1">
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>₹{subTotal.toFixed(2)}</span>
            </div>
            {Object.entries(totals.taxes).map(([name, amount]) => (
              <div key={name} className="flex justify-between">
                <span>{name} (included)</span><span>₹{amount.toFixed(2)}</span>
              </div>
            ))}
            <div className="flex justify-between">
              <span>Discount</span>
              <span>-₹{discount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span>Round Off</span>
              <span>₹{roundOff.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-yellow-400 font-semibold text-base">
              <span>{refundMode ? "REFUND" : "NET"}</span>
              <span>
                ₹{refundMode ? `-${Math.abs(grandTotal)}` : grandTotal}
              </span>
            </div>
          </div>
        </div>

        <div className="pos-panel pos-receipt col-span-1 bg-white text-black p-3 font-mono text-xs rounded-xl" aria-label="Receipt preview">
          <div className="pos-receipt-heading"><span>RECEIPT PREVIEW</span><span>{bill.length===0&&lastPrintedBill?'SAVED':'LIVE DRAFT'}</span></div>
          <div className="pos-paper-frame">
          {bill.length===0&&lastPrintedBill ? <BillReceipt bill={lastPrintedBill} receiptId="inlineSavedReceipt"/> : <div id="receipt" className="w-[320px] mx-auto">
            {refundMode && (
              <div className="text-center font-bold text-red-600">
                *** REFUND RECEIPT ***
              </div>
            )}
            <div className="text-center font-bold">{receiptIdentity?.legal_name || STORE.name}</div>
            {(receiptIdentity?.branch_name||user?.branch_name)&&<div className="text-center">{receiptIdentity?.branch_name||user.branch_name}</div>}
            {receiptIdentity?.address&&<div className="text-center whitespace-pre-line">{receiptIdentity.address}</div>}
            {receiptIdentity?.gstin&&<div className="text-center">GSTIN: {receiptIdentity.gstin}</div>}
            {receiptIdentity?.phone&&<div className="text-center">Contact: {receiptIdentity.phone}</div>}
            <div className="text-center">Bill number assigned after payment</div>
            <div className="text-center font-bold">DRAFT — NOT A PAYMENT RECEIPT</div>
            {tokenNo&&<div className="text-center">Token: {tokenNo}</div>}
            {customer?.name&&<div className="pos-paper-guest">{customer.name}{customer.mobile&&<span> · {customer.mobile}</span>}</div>}

            <hr className="my-1" />
            <div className="text-center font-bold">Items</div>
            {bill.map((b) => (
              <div key={b.id} className="pos-paper-line">
                <div><strong>{b.name}</strong><small>Department: {b.source_department_name||allItems.find(item=>item.id===b.id)?.source_department_name||'Not recorded'}</small><small>
                  {isWeightItem(b)
                    ? `${Number(b.grams || 0)}g × ₹${b.overriddenPrice ?? b.price}/kg`
                    : `${b.qty} ${b.uom || "PCS"} × ₹${b.overriddenPrice ?? b.price}`}
                </small></div><strong>₹{lineAmount(b).toFixed(2)}</strong>
              </div>
            ))}
            <hr className="my-2" />
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>₹{subTotal.toFixed(2)}</span>
            </div>
            {Object.entries(totals.taxes).map(([name,amount])=><div key={name} className="flex justify-between"><span>{name} (included)</span><span>₹{amount.toFixed(2)}</span></div>)}
            <div className="flex justify-between">
              <span>Discount</span>
              <span>-₹{discount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <strong>Total</strong>
              <strong>
                ₹{refundMode ? `-${Math.abs(grandTotal)}` : grandTotal}
              </strong>
            </div>
            {remarks&&<div className="text-center mt-1 whitespace-pre-line">{remarks}</div>}
            {(typeof receiptIdentity?.footer==='string' ? receiptIdentity.footer.split('\n') : ['Thank you. Visit again.']).map((f, i) => (
              <div key={i} className="text-center text-[10px] whitespace-pre-line">
                {f}
              </div>
            ))}
          </div>}
          </div>
          <div className="pos-receipt-footnote">{bill.length===0&&lastPrintedBill?'Saved payment receipt. Use Print to reprint.':'Preview only · a valid receipt is issued after payment.'}</div>
        </div>

        <div className="pos-panel pos-controls rounded-xl bg-white/5 backdrop-blur-xl border border-yellow-500/20 p-3">
          <div className="pos-keypad-entry">
          <div className="text-yellow-400 text-xs tracking-widest mb-2">
            KEYPAD
          </div>
          {selectedRow&&bill.filter(row=>row.id===selectedRow).map(row=><label key={row.id} className="block text-sm mb-4">{isWeightItem(row)?'Weight in grams':'Quantity'} · {row.name}<input aria-label={isWeightItem(row)?'Selected item grams':'Selected item quantity'} type="number" min="0" step={isWeightItem(row)?'1':'0.001'} value={isWeightItem(row)?row.grams:row.qty} className="pos-item-search" onChange={e=>setBill(prev=>prev.map(item=>item.id===row.id?{...item,[isWeightItem(row)?'grams':'qty']:Number(e.target.value)}:item))} /></label>)}
          <div className="pos-keypad-modes grid grid-cols-3 gap-2 mb-2">
            <button
              onClick={() => {
                const selected = bill.find((item) => item.id === selectedRow);

                if (!selected) return alert("Select an item first");

                if (isWeightItem(selected)) {
                  return alert("Use WT for KG items");
                }

                setKeypadMode("qty");
              }}
              className="btn"
            >
              QTY
            </button>

            <button
              onClick={() => {
                const selected = bill.find((item) => item.id === selectedRow);

                if (!selected) return alert("Select an item first");

                if (!isWeightItem(selected)) {
                  return alert("Weight billing is available only for KG items");
                }

                setKeypadMode("weight");
              }}
              className="btn"
            >
              WT
            </button>

            <button
              disabled={!allow('pos.price_override')}
              onClick={() => {
                if (!selectedRow) return alert("Select an item first");
                setKeypadMode("price");
              }}
              className="btn"
            >
              PRICE
            </button>
          </div>

          <div className="pos-line-actions grid grid-cols-2 gap-2 mb-2">
            <button
              onClick={() => {
                if (!selectedRow) return;
                setBill(bill.filter((b) => b.id !== selectedRow));
                setSelectedRow(null);
              }}
              className="rounded-lg p-3 bg-red-600"
            >
              VOID LINE
            </button>

            <button
              onClick={() => setShowClearConfirm(true)}
              className="rounded-lg p-3 bg-red-700"
            >
              CLEAR BILL
            </button>
          </div>

          <div className="pos-number-pad grid grid-cols-3 gap-2">
            {["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "DEL"].map(
              (k) => (
                <button
                  key={k}
                  onClick={() => onKeypad(k)}
                  className="rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
                >
                  {k}
                </button>
              ),
            )}
            <button
              onClick={() => onKeypad("C")}
              className="col-span-3 rounded-lg p-3 bg-zinc-800 border border-yellow-500/30"
            >
              Clear
            </button>
          </div>
          </div>
          <div className="pos-sale-actions">
          <div className="grid grid-cols-4 gap-2 mt-2">
            <button
              disabled={!allow('pos.sell')}
              onClick={() => {
                setKeypadTarget("paid");
                setMode("Cash");
                setShowPay(true);
              }}
              className="rounded-lg p-3 bg-yellow-400 text-black"
            >
              Cash
            </button>
            <button
              onClick={() => {
                setKeypadTarget("paid");
                setMode("UPI");
                setShowPay(true);
              }}
              disabled={!allow('pos.sell')}
              className="rounded-lg p-3 bg-yellow-400 text-black"
            >
              QR / UPI
            </button>
            <button
              onClick={() => {
                setKeypadTarget("paid");
                setMode("Card");
                setShowPay(true);
              }}
              disabled={!allow('pos.sell')}
              className="rounded-lg p-3 bg-yellow-400 text-black"
            >
              Card
            </button>
            <button disabled={!allow('pos.sell')} onClick={()=>{setKeypadTarget("paid");setMode("Zomato");setPaid(grandTotal);setShowPay(true);}} className="rounded-lg p-3 bg-yellow-400 text-black">Platforms</button>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <button
              disabled={!allow('pos.print')}
              onClick={doPrint}
              className="rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
            >
              Print
            </button>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <button
              disabled={!allow('pos.hold')}
              onClick={holdBill}
              className="rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
            >
              Hold
            </button>
            <button
              disabled={!allow('pos.refund')}
              onClick={() => { setShowSearch(true); setSelectedBill(null); }}
              className={`rounded-lg p-3 ${
                refundMode ? "bg-red-500" : "bg-zinc-900"
              } border border-yellow-500/30`}
            >
              Refund Original Bill
            </button>
          </div>
          <button
            disabled={!allow('pos.discount')}
            onClick={() => setShowDiscount(true)}
            className="rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
          >
            Discount
          </button>
          <button
            onClick={() => setShowRemarks(true)}
            className="mt-2 w-full rounded-lg p-3 bg-zinc-900 border border-yellow-500/30"
          >
            Remarks
          </button>
          <button
            onClick={loadDayClosing}
            className="mt-2 w-full rounded-lg p-3 bg-red-600 text-white"
          >
            Day Closing
          </button>
          {lastPrintedBill && <button className="pos-last-receipt rounded-lg p-3 bg-zinc-900 border border-amber-400/30" onClick={()=>setShowReceiptPreview(true)}>View last receipt · {lastPrintedBill.bill_no}</button>}
          </div>
        </div>

        {showDiscount && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
            <div className="bg-zinc-900 p-5 rounded-xl w-80 border border-yellow-500/30">
              <div className="text-yellow-400 mb-2">Apply Discount</div>
              <input
                aria-label="Discount value"
                className="w-full bg-black p-2 rounded"
                type="number"
                min="0"
                max={discountMode==='percent'?100:subTotal}
                step="0.01"
                value={discountEntry}
                onChange={(e) => setDiscountEntry(e.target.value)}
              />
              <select aria-label="Discount type" className="w-full bg-black p-2 mt-3 rounded" value={discountMode} onChange={e=>setDiscountMode(e.target.value)}><option value="amount">Fixed amount (₹)</option><option value="percent">Percentage (%)</option></select>
              <p className="text-xs text-gray-400 mt-3">Deducted from the final customer total. Included GST is recalculated after discount. Existing manager approval limits still apply.</p>
              <div className="flex justify-end gap-2 mt-3">
                <button
                  onClick={() => setShowDiscount(false)}
                  className="px-3 py-2"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {const value=Number(discountEntry);if(!Number.isFinite(value)||value<0||(discountMode==='percent'&&value>100)||(discountMode==='amount'&&value>subTotal))return alert('Enter a valid discount within the bill total');setAppliedPercent(discountMode==='percent'?value:null);setDiscount(discountMode==='percent'?Math.round(subTotal*value)/100:Math.round(value*100)/100);setShowDiscount(false);}}
                  className="px-3 py-2 bg-yellow-400 text-black rounded"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}

        {showPay && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
            <div className="bg-zinc-900 p-5 rounded-xl w-80 border border-yellow-500/30">
              <div className="text-yellow-400 mb-2">Payment</div>
              <select
                disabled={saving || paymentUncertain || approvalReady}
                aria-label="Payment channel"
                className="w-full bg-black p-2 rounded"
                value={mode}
                onChange={(e) => setMode(e.target.value)}
              >
                <option>Cash</option>
                <option value="UPI">QR / UPI</option>
                <option>Card</option>
                <option>Zomato</option><option>Swiggy</option><option value="Other Platform">Other Platform</option>
              </select>
              <input
                disabled={saving || paymentUncertain || approvalReady}
                className="w-full bg-black p-2 rounded mt-2"
                placeholder="Paid Amount"
                type="number"
                value={paid}
                onChange={(e) => setPaid(Number(e.target.value))}
              />
              <div className="mt-2 text-sm">
                {change < 0 ? 'Amount still due:' : 'Change:'} ₹{Math.abs(change).toFixed(2)}
              </div>
              <div className="flex justify-end gap-2 mt-3">
                <button disabled={saving || paymentUncertain} onClick={() => {setShowPay(false);setApprovalReady(false);paymentRequestRef.current=null;clearPending(user);}} className="px-3 py-2">
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    if (savingRef.current) return;
                    savingRef.current = true;
                    setSaving(true);
                    try {
                      if (!sessionReady) return alert('Open the counter first');
                      if (!paymentUncertain && bill.some(item => {
                        const live = allItems.find(row => row.id === item.id);
                        return !live || itemBlockReason(live, true) || !Number.isFinite(requestedQuantity(item)) || requestedQuantity(item) <= 0;
                      })) return alert('One or more items are unavailable or have invalid quantities. Refresh the menu and review the bill before payment.');
                      if (bill.length === 0) {
                        alert("No items in bill");
                        return;
                      }

                      if (!refundMode && mode === "Cash" && paid < grandTotal) {
                        alert("Insufficient cash received");
                        return;
                      }

                      const invalidWeight = bill.find(
                        (item) =>
                          isWeightItem(item) && Number(item.grams || 0) <= 0,
                      );

                      if (invalidWeight) {
                        alert(`Enter grams for ${invalidWeight.name}`);
                        return;
                      }

                      const data = await saveBill();

                      if (data.status !== "success") {
                        if(data.approval_required){setPaymentUncertain(false);setManagerApproval({action:'sale',payload:paymentRequestRef.current});return;}
                        paymentRequestRef.current = null;
                        setApprovalReady(false);
                        clearPending(user);
                        setPaymentUncertain(false);
                        alert(data.message || "Failed to save bill");
                        return;
                      }

                      setBillNo(data.bill_no);
                      setTokenNo(data.token_no);

                      setLastPrintedBill({
                        ...paymentSnapshotRef.current,
                        items:data.items||paymentSnapshotRef.current.items,
                        bill_no: data.bill_no,
                        token_no: data.token_no,
                        created_at: new Date().toISOString(),
                      });
                      try {
                        const receiptRes=await fetch(`/api/pos/bill/${data.bill_id}`,{credentials:'include'});
                        const receipt=await receiptRes.json();if(receipt.status==='success')setLastPrintedBill(receipt.bill);
                      } catch(error){console.error('Receipt retrieval:',error);}
                      paymentRequestRef.current = null;
                      setApprovalReady(false);
                      clearPending(user);
                      setPaymentUncertain(false);

                      alert(
                        refundMode ? "Refund Completed" : "Payment Successful",
                      );

                      setBill([]);
                      setCustomer(null);
                      setPaid(0);
                      setDiscount(0);
                      setRemarks("");
                      setRefundMode(false);
                      setHoldId(null);

                      await loadMenu();

                      setBillNo(genBillNo());
                      setInvoiceId(genInvoiceId());

                      await loadHolds();
                      setShowPay(false);
                    } catch (err) {
                      console.error(err);
                      if (paymentRequestRef.current) setPaymentUncertain(true);
                      alert(paymentRequestRef.current?"Payment response could not be confirmed. Retry Complete with the same request; it will not save the bill twice. Do not start another sale yet.":err.message);
                    } finally {
                      savingRef.current = false;
                      setSaving(false);
                    }
                  }}
                  className="px-3 py-2 bg-yellow-400 text-black rounded"
                  disabled={saving || bill.length === 0 || !allow('pos.sell')}
                >
                  {saving ? "Saving..." : paymentUncertain ? "Retry Same Payment" : "Complete Payment"}
                </button>
              </div>
            </div>
          </div>
        )}

        {showRemarks && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
            <div className="bg-zinc-900 p-5 rounded-xl w-80 border border-yellow-500/30">
              <div className="text-yellow-400 mb-2">Remarks</div>
              <textarea
                className="w-full bg-black p-2 rounded"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Add a note on receipt..."
              />
              <div className="flex justify-end gap-2 mt-3">
                <button
                  onClick={() => setShowRemarks(false)}
                  className="px-3 py-2"
                >
                  Cancel
                </button>
                <button
                  onClick={() => setShowRemarks(false)}
                  className="px-3 py-2 bg-yellow-400 text-black rounded"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {showClearConfirm && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
            <div className="bg-zinc-900 p-5 rounded-xl w-80 border border-yellow-500/30">
              <div className="text-yellow-400 mb-2">Clear Bill?</div>
              <p className="text-sm text-gray-400">
                This will remove all items.
              </p>
              <div className="flex justify-end gap-2 mt-3">
                <button onClick={() => setShowClearConfirm(false)}>
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setBill([]);
                    setShowClearConfirm(false);
                  }}
                  className="bg-red-600 px-3 py-2 rounded"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {lastPrintedBill && <div className="pos-saved-receipt"><BillReceipt bill={lastPrintedBill} receiptId="lastReceipt" /></div>}
      {showReceiptPreview && lastPrintedBill && <div className="fixed inset-0 bg-black/70 flex items-center justify-center"><div className="bg-zinc-900 p-6"><div className="flex justify-between gap-4 mb-4"><h2>Saved receipt</h2><button onClick={()=>setShowReceiptPreview(false)}>Close</button></div><BillReceipt bill={lastPrintedBill} receiptId="previewReceipt" /><button onClick={doPrint} className="w-full mt-4 rounded-lg p-3 bg-amber-400 text-black">Print 80 mm receipt</button></div></div>}
      {managerApproval&&<ManagerApproval {...managerApproval} onClose={()=>{if(managerApproval.action==='sale'){paymentRequestRef.current=null;setApprovalReady(false);clearPending(user);}setManagerApproval(null);}} onApproved={id=>{const action=managerApproval.action;setManagerApproval(null);if(action==='sale'){paymentRequestRef.current.approval_id=id;setApprovalReady(true);writePending(user,{payload:paymentRequestRef.current,snapshot:paymentSnapshotRef.current});}else if(action==='void')voidBill(id);else refundBill(id);}} />}
      {showCashMovement&&user&&<CashMovementModal user={user} onClose={()=>setShowCashMovement(false)} onSaved={()=>{setShowCashMovement(false);alert('Cash movement saved');}} />}
      {showOpening && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
          <div className="bg-zinc-900 p-6 rounded-xl w-96">
            <h2 className="text-xl text-yellow-400 mb-4">Day Opening</h2>
            <p className="mb-3 text-sm text-gray-400">Default opening balance is ₹10,000. Confirm the actual cash float before starting.</p>

            <input
              type="number"
              aria-label="Counter opening balance" min="0" step="0.01"
              placeholder="Opening balance — ₹10,000 default"
              value={openingCash}
              onChange={(e) => setOpeningCash(e.target.value)}
              className="w-full bg-black p-3 rounded"
            />

            <textarea
              placeholder="Remarks"
              value={openingRemarks}
              onChange={(e) => setOpeningRemarks(e.target.value)}
              className="w-full bg-black p-3 rounded mt-3"
            />

            <button
              onClick={openDay}
              disabled={!allow('pos.day_open')}
              className="w-full mt-4 bg-yellow-400 text-black p-3 rounded"
            >
              Start Billing
            </button>
          </div>
        </div>
      )}

      {showDayClosing && closingSummary && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div role="dialog" aria-modal="true" aria-label="End-of-day counter summary" className="bg-zinc-900 w-full max-w-xl max-h-[94dvh] overflow-y-auto rounded-xl p-6 border border-yellow-500">
            <h2 className="text-xl font-bold text-yellow-400 mb-5">
              End-of-Day Summary
            </h2>
            <CounterPaymentSummary summary={closingSummary}/>
            <fieldset className="grid grid-cols-3 gap-2 mb-4"><legend className="text-sm text-gray-400 mb-2">Optional cash denomination count</legend>{[500,200,100,50,20,10,5,2,1].map(note=><label key={note} className="text-xs">₹{note}<input aria-label={`Count of ${note} rupee notes or coins`} type="number" min="0" step="1" value={denominations[note]??''} className="w-full p-2 bg-black" onChange={e=>{const next={...denominations,[note]:Math.max(0,Math.trunc(Number(e.target.value)))};setDenominations(next);setClosingActualCash(Object.entries(next).reduce((sum,[value,count])=>sum+Number(value)*count,0));}} /></label>)}</fieldset>
            <textarea aria-label="Closing difference reason" placeholder="Reason for cash shortage/surplus (required if cash differs)" value={closingReason} onChange={e=>setClosingReason(e.target.value)} className="w-full bg-black p-3 rounded mb-4" />

            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span>Refunds (already included above)</span>
                <span className="text-red-400">
                  ₹{closingSummary.refunds.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between"><span>Cash In</span><span>₹{Number(closingSummary.cash_in||0).toFixed(2)}</span></div>
              <div className="flex justify-between"><span>Cash Out</span><span>₹{Number(closingSummary.cash_out||0).toFixed(2)}</span></div>

              <div className="flex justify-between">
                <span>Expenses</span>
                <span className="text-red-400">
                  ₹{closingSummary.expenses.toFixed(2)}
                </span>
              </div>
            </div>

            <hr className="my-5 border-zinc-700" />

            <div className="flex justify-between font-bold text-yellow-400 text-lg mb-5">
              <span>Expected Cash</span>
              <span>₹{closingSummary.expected_cash.toFixed(2)}</span>
            </div>

            <label className="block text-sm mb-2">Actual Cash Counted</label>

            <input
              type="number"
              value={closingActualCash}
              onChange={(e) => setClosingActualCash(e.target.value)}
              className="w-full p-3 rounded bg-black border border-gray-600 text-white"
            />

            <div className="flex justify-between mt-5 text-base">
              <span>Difference</span>

              <span
                className={
                  Number(closingActualCash) === closingSummary.expected_cash
                    ? "text-green-400 font-bold"
                    : Number(closingActualCash) > closingSummary.expected_cash
                      ? "text-blue-400 font-bold"
                      : "text-red-400 font-bold"
                }
              >
                ₹
                {(
                  Number(closingActualCash) - closingSummary.expected_cash
                ).toFixed(2)}
              </span>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowDayClosing(false)}
                className="px-4 py-2 bg-zinc-700 rounded"
              >
                Cancel
              </button>

              <button
                onClick={closeDay}
                disabled={closingLoading||!allow('pos.day_close')}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded"
              >
                {closingLoading ? "Closing..." : "Close Day"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showVoid && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[1000]">
          <div className="bg-zinc-900 rounded-xl p-6 w-[400px]">
            <h2 className="text-xl font-semibold text-red-500 mb-4">
              Void Bill
            </h2>

            <textarea
              className="w-full bg-black rounded p-3 border border-zinc-700"
              rows={4}
              placeholder="Reason for void..."
              value={voidReason}
              onChange={(e) => setVoidReason(e.target.value)}
            />

            <div className="flex justify-end gap-2 mt-5">
              <button
                onClick={() => {
                  setShowVoid(false);
                  setVoidReason("");
                }}
                className="bg-zinc-700 px-4 py-2 rounded"
              >
                Cancel
              </button>

              <button
                onClick={voidBill}
                disabled={voidLoading}
                className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
              >
                {voidLoading ? "Voiding..." : "Void Bill"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSearch && (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center">
          <div className="bg-zinc-900 rounded-xl p-5 w-[900px]">
            <h2 className="text-xl mb-4">Bill Search</h2>

            <div className="flex gap-2">
              <input
                placeholder="Bill No"
                value={billSearch}
                onChange={(e) => setBillSearch(e.target.value)}
                className="bg-black p-2 rounded w-full"
              />

              <input
                placeholder="Token"
                value={tokenSearch}
                onChange={(e) => setTokenSearch(e.target.value)}
                className="bg-black p-2 rounded w-full"
              />

              <button
                onClick={searchBills}
                className="bg-yellow-500 text-black px-4 rounded"
              >
                Search
              </button>
            </div>

            <div className="mt-5 max-h-[400px] overflow-auto">
              <PaginatedTable className="w-full">
                <thead>
                  <tr>
                    <th>Bill</th>
                    <th>Token</th>
                    <th>Total</th>
                    <th>Mode</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {billResults.map((b) => (
                    <tr key={b.id}>
                      <td>{b.bill_no}</td>

                      <td>{b.token_no}</td>

                      <td>₹{b.grand_total}</td>

                      <td>{b.payment_mode}</td>

                      <td>
                        {b.void ? "VOID" : b.refund ? "REFUND" : "NORMAL"}
                      </td>

                      <td><TableActions>
                        <button
                          onClick={() => loadBill(b.id)}
                          className="text-yellow-400"
                        >
                          View
                        </button>
                      </TableActions></td>
                    </tr>
                  ))}
                </tbody>
              </PaginatedTable>
            </div>

            <button
              onClick={() => setShowSearch(false)}
              className="mt-5 bg-red-500 px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {selectedBill && (
        <div className="fixed inset-0 bg-black/80 flex justify-center items-center">
          <div className="bg-zinc-900 rounded-xl p-6 w-[500px]">
            <h2>{selectedBill.bill_no}</h2>

            <h3>Token : {selectedBill.token_no}</h3>

            <hr className="my-3" />

            {selectedBill.items.map((i, index) => (
              <div key={index} className="flex justify-between">
                <span>
                  {i.name}({i.qty})
                </span>

                <span>₹{i.amount}</span>
              </div>
            ))}

            <hr className="my-3" />

            <div className="font-bold">Total ₹{selectedBill.grand_total}</div>
            <div className="font-bold">
              Payment : {selectedBill.payment_mode}
            </div>
            <div className="font-bold">
              Remarks : {selectedBill.remarks || "-"}
            </div>

            <div className="pos-saved-receipt">
              <BillReceipt bill={selectedBill} />
            </div>
            {billAudit.length>0&&<div className="max-h-40 overflow-auto text-xs space-y-2 mt-3">{billAudit.map((entry,index)=><div key={index} className="border border-white/10 p-2 rounded"><strong>{entry.action}</strong> · {entry.actor_name} ({entry.employee_code||'—'}) · {new Date(entry.created_at).toLocaleString()}<div>{JSON.stringify(entry.details)}</div></div>)}</div>}

            <div className="flex gap-2 mt-5">
              <button className="bg-zinc-800 px-4 py-2 rounded" onClick={async()=>{try{const res=await fetch(`/api/pos/audit/${selectedBill.id}`,{credentials:'include'});const data=await res.json();setBillAudit(data.data||[]);}catch(e){alert('Could not load audit history');}}}>Audit History</button>
              <button
                onClick={printOldBill}
                disabled={!allow('pos.print')}
                className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded"
              >
                Reprint
              </button>

              <button
                onClick={() => {
                  if (selectedBill.void) return;

                  setVoidBillId(selectedBill.id);
                  setShowVoid(true);
                }}
                disabled={!allow('pos.void')||selectedBill?.void === true || selectedBill.was_refunded || selectedBill.is_day_closed}
                className={`px-4 py-2 rounded ${
                  selectedBill?.void
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-red-600 hover:bg-red-700"
                }`}
              >
                {selectedBill?.void ? "Voided" : "Void"}
              </button>

              <button
                onClick={() => {
                  setRefundBillId(selectedBill.id);
                  setShowRefund(true);
                }}
                disabled={!allow('pos.refund')||selectedBill.refund || selectedBill.void || selectedBill.was_refunded}
                className={`px-4 py-2 rounded ${
                  selectedBill.refund || selectedBill.void
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-yellow-500 hover:bg-yellow-600 text-black"
                }`}
              >
                {selectedBill.refund ? "Refunded" : "Refund"}
              </button>
              <button
                onClick={() => setSelectedBill(null)}
                className="mt-5 bg-zinc-700 px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showRefund && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-zinc-900 p-6 rounded-xl w-[420px]">
            <h2 className="text-xl text-yellow-400 mb-4">Refund Bill</h2>

            <textarea
              rows={4}
              value={refundReason}
              onChange={(e) => setRefundReason(e.target.value)}
              placeholder="Reason for refund..."
              className="w-full bg-black border border-zinc-700 rounded p-3"
            />

            <div className="mt-4">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={returnToInventory}
                  onChange={(e) => setReturnToInventory(e.target.checked)}
                  className="w-4 h-4"
                />

                <span>Return items to inventory</span>
              </label>

              <p className="text-xs text-gray-400 mt-2">
                Uncheck this if the returned items are damaged, spoiled, or
                cannot be sold again.
              </p>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setShowRefund(false);
                  setRefundReason("");
                  setReturnToInventory(true);
                }}
                className="bg-zinc-700 px-4 py-2 rounded"
              >
                Cancel
              </button>

              <button
                onClick={refundBill}
                disabled={refundLoading}
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded"
              >
                {refundLoading ? "Refunding..." : "Refund"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showExpense && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-zinc-900 rounded-xl w-[450px] border border-yellow-500/20 p-6">
            <h2 className="text-2xl font-semibold text-yellow-400 mb-6">
              Add Expense
            </h2>

            {/* Expense Type */}
            <div className="mb-4">
              <label className="block text-sm text-zinc-300 mb-2">
                Expense Type
              </label>

              <select
                value={expenseType}
                onChange={(e) => setExpenseType(e.target.value)}
                className="w-full bg-black border border-zinc-700 rounded-lg p-3 text-white"
              >
                <option value="">Select Expense</option>
                <option value="Petty Cash">Petty Cash</option>
                <option value="Cleaning">Cleaning</option>
                <option value="Packaging">Packaging</option>
                <option value="Transportation">Transportation</option>
                <option value="Maintenance">Maintenance</option>
                <option value="Staff Meal">Staff Meal</option>
                <option value="Fuel">Fuel</option>
                <option value="Electricity">Electricity</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Amount */}
            <div className="mb-4">
              <label className="block text-sm text-zinc-300 mb-2">Amount</label>

              <input
                type="number"
                value={expenseAmount}
                onChange={(e) => setExpenseAmount(e.target.value)}
                placeholder="Enter amount"
                className="w-full bg-black border border-zinc-700 rounded-lg p-3 text-white"
              />
            </div>

            {/* Remarks */}
            <div className="mb-6">
              <label className="block text-sm text-zinc-300 mb-2">
                Remarks
              </label>

              <textarea
                rows={4}
                value={expenseRemarks}
                onChange={(e) => setExpenseRemarks(e.target.value)}
                placeholder="Remarks (optional)"
                className="w-full bg-black border border-zinc-700 rounded-lg p-3 text-white"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowExpense(false);
                  setExpenseType("");
                  setExpenseAmount("");
                  setExpenseRemarks("");
                }}
                className="bg-zinc-700 hover:bg-zinc-600 px-5 py-2 rounded-lg"
              >
                Cancel
              </button>

              <button
                onClick={saveExpense}
                disabled={expenseLoading}
                className="bg-yellow-500 hover:bg-yellow-400 text-black px-5 py-2 rounded-lg font-semibold"
              >
                {expenseLoading ? "Saving..." : "Save Expense"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
